module.exports = __webpack_public_path__ + "img/key_features--efficiency.2431b0ec.png";